
import React, { useState, useEffect } from 'react';
import {
    Button,
    Form,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    FormGroup,
    Label,
    Input,
    Row,
    Col,
} from 'reactstrap';


const EditAgencyModal = ({ show, onHide, agency, updateAgency }) => {
    const [formData, setFormData] = useState({});

    useEffect(() => {
        if (agency) {
            // Initialize form data based on the agency prop
            // Assuming agency prop might have camelCase keys, convert to snake_case if necessary
            // or expect snake_case directly. For now, let's assume it might be mixed or camelCase
            // and we map to the snake_case keys expected by the backend/mutation.
            setFormData({
                agency_name: agency.agencyName || agency.agency_name || '',
                agency_phone: agency.agencyPhone || agency.agency_phone || '',
                agency_address: agency.agencyAddress || agency.agency_address || '',
                first_name: agency.firstName || agency.first_name || '',
                last_name: agency.lastName || agency.last_name || '',
                email: agency.email || '',
                phone: agency.phone || '',
                active: agency.active === undefined ? true : !!agency.active, // Default to true if undefined
            });
        }
    }, [agency, show]); // Re-initialize if agency changes or modal is reshown with a new agency

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!agency || !agency.id) {
            console.error("Agency data is missing for update.");
            // Optionally, show an error to the user
            return;
        }
        // Prepare data for mutation, ensuring keys are snake_case
        const updateData = {
            agency_name: formData.agency_name,
            agency_phone: formData.agency_phone,
            agency_address: formData.agency_address,
            first_name: formData.first_name,
            last_name: formData.last_name,
            email: formData.email,
            phone: formData.phone,
            active: formData.active,
        };
        updateAgency({ agencyId: agency.id, updateData });
        onHide(); // Close modal after submission
    };

    if (!agency) {
        return null; // Or a loading spinner, or some other placeholder
    }

    return (
        <Modal isOpen={show} toggle={onHide} centered>
            <ModalHeader toggle={onHide}>
                <> Agency: {agency.agencyName || agency.agency_name}</>
            </ModalHeader>
            <Form onSubmit={handleSubmit}>
                <ModalBody>
                    <Row>
                        <Col md={6}>
                            <FormGroup className="mb-3">
                                <Label for="formAgencyName">Agency Name</Label>
                                <Input
                                    type="text"
                                    placeholder="Enter agency name"
                                    name="agency_name"
                                    id="formAgencyName"
                                    value={formData.agency_name || ''}
                                    onChange={handleChange}
                                    required
                                />
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup className="mb-3">
                                <Label for="formAgencyPhone">Agency Phone</Label>
                                <Input
                                    type="text"
                                    placeholder="Enter agency phone"
                                    name="agency_phone"
                                    id="formAgencyPhone"
                                    value={formData.agency_phone || ''}
                                    onChange={handleChange}
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={12}>
                            <FormGroup className="mb-3">
                                <Label for="formAgencyAddress">Agency Address</Label>
                                <Input
                                    type="textarea"
                                    rows={3}
                                    placeholder="Enter agency address"
                                    name="agency_address"
                                    id="formAgencyAddress"
                                    value={formData.agency_address || ''}
                                    onChange={handleChange}
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <hr />
                    <h5>Contact Person</h5>

                    <Row>
                        <Col md={6}>
                            <FormGroup className="mb-3">
                                <Label for="formFirstName">First Name</Label>
                                <Input
                                    type="text"
                                    placeholder="Enter contact first name"
                                    name="first_name"
                                    id="formFirstName"
                                    value={formData.first_name || ''}
                                    onChange={handleChange}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup className="mb-3">
                                <Label for="formLastName">Last Name</Label>
                                <Input
                                    type="text"
                                    placeholder="Enter contact last name"
                                    name="last_name"
                                    id="formLastName"
                                    value={formData.last_name || ''}
                                    onChange={handleChange}
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={6}>
                            <FormGroup className="mb-3">
                                <Label for="formEmail">Email</Label>
                                <Input
                                    type="email"
                                    placeholder="Enter contact email"
                                    name="email"
                                    id="formEmail"
                                    value={formData.email || ''}
                                    onChange={handleChange}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup className="mb-3">
                                <Label for="formPhone">Phone</Label>
                                <Input
                                    type="text"
                                    placeholder="Enter contact phone"
                                    name="phone"
                                    id="formPhone"
                                    value={formData.phone || ''}
                                    onChange={handleChange}
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={12}>
                            <FormGroup check className="mb-3">
                                <Input
                                    type="checkbox"
                                    name="active"
                                    id="formActive"
                                    checked={formData.active || false}
                                    onChange={handleChange}
                                />
                                {' '}
                                <Label check for="formActive">
                                    Active
                                </Label>
                            </FormGroup>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={onHide}>
                        Close
                    </Button>
                    <Button color="primary" type="submit">
                        Save Changes
                    </Button>
                </ModalFooter>
            </Form>
        </Modal>
    );
};

export default EditAgencyModal;